import Container from '@components/container';
import { ContainerSize, Video } from '@lib/types';

export default function VideoSection({ data: { video } }: { data: Video }) {
  if (!video) return null;

  let __html = video.rawData.html;

  // append vimeo start-time-fragment to iframe src
  if (video.rawData.provider_name === 'Vimeo') {
    const vimeoStartAt = video.url.match(/(t=[0-9]*s)/);
    if (vimeoStartAt) {
      __html = __html.replace(/src="(.*?)"/, `src="$1#${vimeoStartAt[0]}"`);
    }
  }

  return (
    <Container size={ContainerSize.wide}>
      <div className="lg:grid grid-cols-12 gap-1.5 md:gap-6">
        <div className="col-start-3 col-span-8">
          <div
            className="aspect-w-16 aspect-h-9 rounded-xl md:rounded-3xl overflow-hidden"
            dangerouslySetInnerHTML={{ __html }}
          />
        </div>
      </div>
    </Container>
  );
}
